/** @typedef {"legacy" | "modern"} ChatLayoutMode */

const MODE_ALIASES = {
	legacy: "legacy",
	classic: "legacy",
	modern: "modern",
	new: "modern",
	tailwick: "modern",
};

/**
 * Valor canônico persistido no banco: legacy | modern.
 * @param {unknown} value
 * @returns {ChatLayoutMode}
 */
export function normalizeChatLayoutMode(value) {
	const key = String(value ?? "")
		.trim()
		.toLowerCase();
	return MODE_ALIASES[key] ?? "legacy";
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isModernChatLayout(value) {
	return normalizeChatLayoutMode(value) === "modern";
}
